import styled from 'styled-components';

export const IconImg = styled.img`
    height: 14px;
    width: auto;
`;

export const LogoImg = styled.img`
    object-fit: contain;
    width: 75%;
    margin: 0 20px;
    ${({ theme }) => theme.superQuery.all.and.minWidth.tabletMin.css`
        width: auto;
        height: 66%;
        object-fit: unset;
    `};
`;

export const LinkContainer = styled.a`
    background: #ffffff;
    height: 72px;
    display: flex;
    align-items: center;
    border-radius: 5px;

    &:hover {
        ${LogoImg} {
            transform: translateX(-2px);
            transition: all 0.2s;
        }
    }
`;



